import { NavLink } from "react-router-dom";
import { Home, ListChecks, Wallet, Bell, UserRound } from "lucide-react";

const TABS = [
  { to: "/app/dashboard", label: "Home",    Icon: Home,        testid: "bottomnav-dashboard" },
  { to: "/app/tasks",     label: "Tasks",   Icon: ListChecks,  testid: "bottomnav-tasks" },
  { to: "/app/wallet",    label: "Wallet",  Icon: Wallet,      testid: "bottomnav-wallet" },
  { to: "/app/messages",  label: "Inbox",   Icon: Bell,        testid: "bottomnav-messages" },
  { to: "/app/profile",   label: "Profile", Icon: UserRound,   testid: "bottomnav-profile" },
];

export default function BottomNav({ unreadCount = 0 }) {
  return (
    <nav
      data-testid="mobile-bottom-nav"
      className="fixed inset-x-0 bottom-0 z-40 h-16 border-t border-neutral-200 bg-white/95 shadow-[0_-4px_16px_-8px_rgba(0,0,0,0.08)] backdrop-blur md:hidden"
      style={{ paddingBottom: "env(safe-area-inset-bottom, 0px)" }}
    >
      <ul className="flex h-16 items-stretch justify-around">
        {TABS.map(({ to, label, Icon, testid }) => (
          <li key={to} className="flex-1">
            <NavLink
              to={to}
              data-testid={testid}
              className={({ isActive }) =>
                `relative flex h-full w-full flex-col items-center justify-center gap-0.5 text-[10px] font-medium transition ${
                  isActive ? "text-amber-700" : "text-neutral-400 hover:text-neutral-600"
                }`
              }
            >
              {({ isActive }) => (
                <>
                  {isActive && (
                    <span className="absolute inset-x-6 top-0 h-0.5 rounded-b-full bg-amber-700" />
                  )}
                  <span className="relative">
                    <Icon className="h-5 w-5" strokeWidth={isActive ? 2.5 : 2} />
                    {label === "Inbox" && unreadCount > 0 && (
                      <span
                        data-testid="bottomnav-inbox-badge"
                        className="absolute -right-1.5 -top-1 flex h-4 min-w-[16px] items-center justify-center rounded-full bg-red-500 px-1 text-[9px] font-bold text-white"
                      >
                        {unreadCount > 9 ? "9+" : unreadCount}
                      </span>
                    )}
                  </span>
                  <span>{label}</span>
                </>
              )}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
